<template>
  <div class="about">
    <div class="about__edit">
      <el-button type="primary" icon="el-icon-edit" circle size="mini" @click="editAbout"></el-button>
    </div>

    <div v-html="!aboutText ? this.$i18n.t('noDetailsProvided') : aboutText"></div>

    <sweet-modal blocking :title="$t('project_tab_info_about_editAbout')" ref="editAbout" class="modal">
      <vue2-custom-editor
          ref="editor"
          style="margin-bottom: 20px;"
          v-model="aboutText"/>

      <div class="modal__btn">
        <el-button @click="modalCancel('editAbout')">{{$t('general_cancel')}}</el-button>
        <el-button @click="updateAbout" type="primary">{{$t('general_submit')}}</el-button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import Vue2CustomEditor from "../../vue-2-custom-editor";

  export default {
    components: {
      SweetModal,
      Vue2CustomEditor,
    },
    data() {
      return {
        aboutText: ''
      }
    },
    watch: {
      about: function (val) {
        this.aboutText = val
      },
    },
    computed: {
      about() {
        return this.$store.state.about.about
      }
    },
    methods: {
      editAbout() {
        this.$refs.editAbout.open()
        this.$refs.editor.setImagesState()
      },
      updateAbout() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagement/about/update?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}`, {
          description: this.aboutText
        })
          .then(async response => {
            await this.$store.dispatch('about', 'engagement')
            
            if (this.$refs.editor.uploadedImagesArray.length) {
              this.$store.dispatch('approveUploadedImages', {
                fileUrlArr: this.$refs.editor.uploadedImagesArray,
                entityId: parseFloat(this.$route.query.engagementId),
                entityTypeId: 9 // eng about
              })
            }

            if (this.$refs.editor.removedImages.length) this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
            this.$refs.editAbout.close()
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
    }
  }
</script>

<style lang="scss" scoped>
.about {
  &__edit {
    position: absolute;
    top: 25px;
    right: 25px;
  }
}
</style>